module.exports = __webpack_public_path__ + "img/gift4.d320f545.png";